import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 商机落标-查询-wy
export const getApprovalInfo = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/lost/query',
        method: 'post',
        data
    });
};
// 商机落标-更新-wy
export const updateApprovalInfo = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/lost/update',
        method: 'post',
        data
    });
};
// 商机落标-更新-wy
export const saveApprovalInfo = (data) => {
    return request({
        url: apiCrmHost + '/opportunity/lost/flow/submit',
        method: 'post',
        data
    });
};
